/**
 * SP3 §5 — default two-up pairing: the active COUPON (primary) beside the
 * transaction's CHECK/payment (companion). Extra coupons/payments become the
 * thumbnail strip; attachments open view-only (kept separate).
 */
import type { StationDocument, StationTransaction } from "../api/client";

export interface PaneSelection {
  primary: StationDocument | null;
  companion: StationDocument | null;
  thumbnails: StationDocument[];
  attachments: StationDocument[];
}

export function selectPaneDocuments(txn: StationTransaction): PaneSelection {
  const coupons = txn.documents.filter((d) => d.role === "coupon");
  const payments = txn.documents.filter((d) => d.role === "payment");
  const attachments = txn.documents.filter((d) => d.role === "attachment" || d.role === null);

  const primary = coupons[0] ?? payments[0] ?? null;
  // The companion is the first payment that ISN'T already the primary — not a
  // hard-coded payments[0]/payments[1] index, so this still holds if the
  // primary/companion selection order above ever changes.
  const companion = payments.find((d) => d.id !== primary?.id) ?? null;

  const usedIds = new Set([primary?.id, companion?.id].filter(Boolean) as string[]);
  const thumbnails = [...coupons, ...payments].filter((d) => !usedIds.has(d.id));
  return { primary, companion, thumbnails, attachments };
}
